module.exports = __webpack_public_path__ + "img/resource-my.c3b8d6c6.png";